"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const searchBarHeight = 66;
const panelPullTabHeight = 20;
const tabBarHeight = 86;
const panelHeader = 75;
const statusBarHeight = react_native_1.StatusBar.currentHeight || 0;
const useDrawerSizes = ({ insets }) => {
    const deviceHeight = react_native_1.Dimensions.get('window').height;
    const DEVICE_HEIGHT = react_native_1.Platform.select({
        ios: deviceHeight,
        android: statusBarHeight > 24 ? deviceHeight + statusBarHeight : deviceHeight,
    }) || deviceHeight;
    const Screen = {
        width: react_native_1.Dimensions.get('window').width,
        height: DEVICE_HEIGHT,
    };
    const expandedHeight = insets.top + searchBarHeight - panelPullTabHeight;
    const partialHeight = Screen.height - Screen.height * 0.5;
    const collapsedHeight = Screen.height - tabBarHeight - panelHeader;
    return {
        expandedHeight,
        partialHeight,
        collapsedHeight,
        deviceHeight: DEVICE_HEIGHT,
    };
};
exports.default = {
    searchBarHeight,
    panelPullTabHeight,
    tabBarHeight,
    panelHeader,
    useDrawerSizes,
};
